<p *ngIf="aviso" class="aviso info">{{ aviso }}</p>
<p *ngIf="naoEncontrada" class="aviso">A conta do atendimento #{{ destacar }} não está entre as 20 mais recentes.</p>

<p *ngIf="!exibidas.length" class="vazio">Nenhuma conta encontrada.</p>

<table *ngIf="exibidas.length">
  <thead>
    <tr>
      <th></th><th>Atendimento</th><th>Data · unidade</th><th class="num">Itens</th><th class="num">Valor</th>
      <th class="num">Pago</th><th class="num">Saldo</th><th>Status</th><th>Convênio</th><th>Usuário</th><th></th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let c of exibidas">
      <tr [attr.data-conta]="c.nrInternoConta" [class.destaque]="contaDestacada === c.nrInternoConta">
        <td class="seta">
          <button type="button" class="seta-btn" (click)="alternar(c)" [attr.aria-expanded]="abertas.has(c.nrInternoConta)"
                  [attr.aria-label]="abertas.has(c.nrInternoConta) ? 'Recolher itens' : 'Ver itens'">{{ abertas.has(c.nrInternoConta) ? '▾' : '▸' }}</button>
        </td>
        <td><span class="forte">#{{ c.nrAtendimento }}</span><div class="sub">Conta #{{ c.nrInternoConta }}</div></td>
        <td>{{ c.dtPeriodoInicial }}<div class="sub trunc" [title]="c.estabelecimento">{{ c.estabelecimento }}</div></td>
        <td class="num">{{ c.qtItens }}</td>
        <td class="num">
          <b>{{ c.vlConta | brl }}</b>
          <div *ngIf="c.vlDesconto > 0" class="sub desc">- {{ c.vlDesconto | brl }}<span *ngIf="c.cupomAplicado"> · {{ c.cupomAplicado }}</span></div>
        </td>
        <td class="num pago">{{ c.vlPago | brl }}</td>
        <td class="num saldo" [class.aberto]="saldo(c) > 0">{{ saldo(c) <= 0 ? 'Quitado' : (saldo(c) | brl) }}</td>
        <td><span class="status" [class.st-def]="definitiva(c)" [class.st-prov]="!definitiva(c)">{{ c.statusConta || 'Provisório' }}</span></td>
        <td>{{ c.dsConvenio || '—' }}</td>
        <td class="sub trunc" [title]="c.nmUsuario">{{ c.nmUsuario }}</td>
        <td class="acoes">
          <button type="button" class="btn btn-sec" title="Vincular adiantamento" (click)="vincular.emit(c)">Vincular</button>
          <button type="button" class="btn" title="Pagar" (click)="pagar.emit(c)">Pagar</button>
          <button *ngIf="supervisor" type="button" class="btn btn-sec mais" title="Ações de supervisor" (click)="abrirMenu($event, c)">⋯</button>
        </td>
      </tr>
      <tr *ngIf="abertas.has(c.nrInternoConta)" class="itens">
        <td></td>
        <td colspan="10">
          <span *ngIf="carregando.has(c.nrInternoConta)" class="sub">Carregando itens…</span>
          <span *ngIf="falhou.has(c.nrInternoConta)" class="sub">Não foi possível carregar os itens.</span>
          <span *ngIf="itens.has(c.nrInternoConta) && !itens.get(c.nrInternoConta)!.length" class="sub">Conta sem itens.</span>
          <table *ngIf="itens.get(c.nrInternoConta)?.length">
            <tr *ngFor="let i of itens.get(c.nrInternoConta)">
              <td class="qtd">{{ i.qtProcedimento }}×</td>
              <td>{{ i.dsProcedimento }}</td>
              <td>{{ i.nomeMedico || '—' }}</td>
              <td class="num">{{ i.vlProcedimento | brl }}</td>
            </tr>
          </table>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>

<div *ngIf="filtro === 'todos' && qtOcultas && !mostrarOcultas" class="mais-wrap">
  <button type="button" class="chip" (click)="mostrarOcultas = true">Ver todas as contas +40 dias ({{ qtOcultas }})</button>
</div>
